import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CarrierDTO } from 'src/app/models/CarrierDTO.model';
import { PlanCarrierDTO } from 'src/app/models/PlanCarrierDTO';
import { PlanDTO } from 'src/app/models/PlanDTO.model';
import { PlanTypeDTO } from 'src/app/models/Plans/PlanTypeDTO';
import { PlanService } from 'src/app/services/plan.service';
import { MultiSelectItem } from 'src/app/shared/controls/multi-select-control/multi-select-control.component';

import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MultiSelectDropdownComponent } from '../../../shared/controls/multi-select-control/multi-select-control.component';
@Component({
    selector: 'app-view-plans',
    templateUrl: './view-plans.component.html',
    styleUrls: ['./view-plans.component.css'],
    imports: [CommonModule, FormsModule, MultiSelectDropdownComponent]
})
export class ViewPlansComponent {
  title: string = 'Create Plan';
  information: string = '';
  filterValue: string = 'Montly';
  planID: number = 0;
  planName: string = '';
  typeData: string = '';
  qtyData: string = '';
  planTypeId: string = '';
  extraFee: string = '';
  description: string = '';
  price: string = '';
  PlanMessage: string = '';
  PlanMessageError: string = '';
  HandleMessage: string = '';
  isUpdate: boolean = false;
  isActivePlan: boolean = false;

  fieldsCompleted: boolean = false;

  plan: PlanDTO = {
    planName: '',
    price: '',
    planTypeId: '',
    typeData: '',
    extraFee: 0,
    description: '',
    state: 1,
  };

  planTypes: PlanTypeDTO[] = [];

    listOfCarriers: CarrierDTO[] = [];
    // Define the carriers as MultiSelectItem
  
    carriers: MultiSelectItem[] = [];
    selectedCarriers: string[] = [];

  constructor(
    private planService: PlanService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit() {
    this.route.params.subscribe((params) => {
      //console.log(params['id']); // Usa el ID para cargar los datos correspondientes
      this.isUpdate = true;
      this.title = 'Plan Summary';
      this.information = 'Plan ID ' + params['id'];
      this.planService.getPlanById(params['id']).subscribe(
        (response: PlanDTO) => {
         
            this.HandleGetPlan(response);
         
        },
        (error) => {
          console.error('Unexpected error fetching customer list:', error);
        }
      );

        this.planService.GetPlanTypes().subscribe(
        (response: PlanTypeDTO[]) => {

            this.planTypes = response;
        },
        (error) => {
          console.error('Unexpected error fetching customer list:', error);
        }
      );
    });
  }


  checkFields() {
    if (
      this.planName &&
      this.typeData &&
      this.qtyData &&
      this.planTypeId &&
      this.price
    ) {
      this.fieldsCompleted = true;
    } else {
      this.fieldsCompleted = false;
    }
  }

  //Este metodo se ejecuta cuando se presiona el boton de regresar
  goBack() {
    window.location.href = '/plans';
  }

  handleSaveError(StatusCode: number) {
    this.PlanMessageError = 'Unexpected error';
    this.planName = '';
    this.typeData = '';
    this.planTypeId = '';
    this.price = '';
    this.extraFee = '';
    this.description = '';
  }

  async handleSaveSuccess(plan: PlanDTO) {
    this.PlanMessage = 'Plan saved successfully';
    this.planName = '';
    this.typeData = '';
    this.planTypeId = '';
    this.qtyData = '';
    this.price = '';
    this.extraFee = '';
    this.description = '';
    await new Promise((resolve) => setTimeout(resolve, 3000));
    location.reload();
  }

  HandleGetPlanError(StatusCode: number) {
    this.HandleMessage = 'Unexpected error';
  }

  HandleGetPlan(plan: PlanDTO) {
    //console.log(plan);
    const data: any = plan;
    this.planID = data.planID;
    this.planName = data.planName;
    this.price =  data.price ? `$ ${Number(data.price).toFixed(2)}` : '$ 0.00';
    this.description = data.description ?? '';
    this.extraFee =  data.extraFee ? `$ ${Number(data.extraFee).toFixed(2)}`  : '$ 0.00';
    this.qtyData = data.qtyData?.toString() ?? '1';
    this.typeData = data.typeData?.toString() ?? '1';
    this.planTypeId = data.planTypeId?.toString() ?? '';
    this.planTypeId = data.planTypeId;
    this.isActivePlan = data.state;
    this.selectedCarriers = data.planCarriers?.map((carrier: PlanCarrierDTO) => carrier.carrierId.toString()) || [];

    this.checkFields();

    this.planService.GetCarriers().subscribe((data: CarrierDTO[]) => {
          // Map the data to MultiSelectItem format
          this.listOfCarriers = data;
    
          this.carriers = data.map((item: CarrierDTO) => {
    
    
            return { id: item.aCarrierId?.toString(), text: item.aCarrierName } as MultiSelectItem;
          });
    
        });
  }
}
